import API from "../../../services/api";
import { 
  CredentialsLoginParam, 
  CredentialsLoginRequest, 
  CredentialsLoginResponse 
} from "../types/credentials";

export enum Endpoints {
  LoginCredentials = "/user/login"
}

const loginCredentials = ({user, password}: CredentialsLoginParam) => {
  return new Promise<CredentialsLoginResponse>(async (resolve, reject) => {
    API.post<CredentialsLoginResponse, CredentialsLoginRequest>({
      endpoint: Endpoints.LoginCredentials,
      data: { user, password }
    })
    .then(res => {
      resolve(res.promise.data);
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  loginCredentials
};